import React, { useEffect, useState } from "react";
import socket from "../../../services/socket";
import "./Notifications.css";
import NotificationCard from "../../components/Notifications/NotificationCard";

import {
  getNotifications,
  markAllNotificationsRead,
} from "../../services/userNotificationService";

const Notifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [filter, setFilter] = useState("All");
  const [loading, setLoading] = useState(true);

  // ============================
  // Fetch Notifications
  // ============================

  const fetchNotifications = async () => {
    try {
      setLoading(true);

      const res = await getNotifications();

      if (res.success) {
        setNotifications(res.notifications);
      }
    } catch (error) {
      console.error("Failed to fetch notifications:", error);
    } finally {
      setLoading(false);
    }
  };

 useEffect(() => {

    fetchNotifications();

    socket.on(

        "new-notification",

        () => {

            fetchNotifications();

        }

    );

    return () => {

        socket.off(

            "new-notification"

        );

    };

}, []);

  // ============================
  // Mark All Read
  // ============================

  const handleMarkAllRead = async () => {
    try {
      await markAllNotificationsRead();
      fetchNotifications();
    } catch (error) {
      console.error(error);
    }
  };

  // ============================
  // Filter Notifications
  // ============================

  const filteredNotifications =
    filter === "All"
      ? notifications
      : notifications.filter(
          (item) => item.type === filter
        );

  return (
    <div className="notifications-page">

      <div className="notifications-header">

        <div>
          <h2>Notifications</h2>

          <p>
            Stay updated with your business activities.
          </p>
        </div>

        <button
          className="mark-read-btn"
          onClick={handleMarkAllRead}
        >
          Mark All Read
        </button>

      </div>

      {/* Filters */}

      <div className="notification-filters">

        {[
          "All",
          "Order",
          "Payment",
          "Review",
          "System",
        ].map((item) => (

          <button
            key={item}
            className={filter === item ? "active" : ""}
            onClick={() => setFilter(item)}
          >
            {item}
          </button>

        ))}

      </div>

      {/* Notification List */}

      <div className="notification-list">

        {loading ? (

          <div className="empty-state">

            <h3>Loading...</h3>

          </div>

        ) : filteredNotifications.length === 0 ? (

          <div className="empty-state">

            <h3>No Notifications</h3>

            <p>You're all caught up.</p>

          </div>

        ) : (

          filteredNotifications.map((notification) => (

            <NotificationCard
    key={notification._id}
    notification={notification}
    onReload={fetchNotifications}
/>

          ))

        )}

      </div>

    </div>
  );
};

export default Notifications;